import { DateHelper } from '../util/dateHelper';
import { Deserializable } from './deserializable';


export class ProgrammedExecution implements Deserializable {

  public static OperationTypeForcedLow: string = "ForceLow";

  public static ResultIdle: string = "Idle";
  public static ResultExecuting: string = "Executing";
  public static ResultExecuted: string = "Executed";
  public static ResultError: string = "Error";


  id: number;
  serial: string;
  operationType: string;
  result: string;
  from: string;
  to: string;

  fromDate: Date;
  toDate: Date;
  timeZone : string;

  fromDateFriendly: string;
  toDateFriendly: string;

  error: string;
  errorDescription: string;
  description: string;

  deserialize(input: any) {
    Object.assign(this, input);

    this.fromDate = new Date(this.from);
    this.toDate = new Date(this.to);

    this.fromDateFriendly = DateHelper.formatDateTimeFriendly(this.fromDate);
    this.toDateFriendly = DateHelper.formatDateTimeFriendly(this.toDate);

    if(this.result == ProgrammedExecution.ResultIdle){
      this.result = $localize`:@@programmedExecutionModel_result_idle:In attesa`;
    } else if(this.result == ProgrammedExecution.ResultExecuting){
      this.result = $localize`:@@programmedExecutionModel_result_executing:In esecuzione`;
    } else if(this.result == ProgrammedExecution.ResultExecuted){
      this.result = $localize`:@@programmedExecutionModel_result_executed:Eseguito`;
    } else if(this.result == ProgrammedExecution.ResultError){
      //aggiungere traduzioni errori

      // if(this.errorDescription == ProgrammedExecution.ErrorCannotStop){
      //   this.result = $localize`:@@programmedExecutionModel_result_error:Errore` + ": " + $localize`:@@programmedExecutionModel_result_error_cannot_stop:Impossibile terminare`;
      // } else{
        //fallback errore non tradotto, da decidere se va lasciato
        this.result = $localize`:@@programmedExecutionModel_result_error:Errore` + ": " + this.errorDescription;
      // }



    }

    return this;
  }

  public static createCopy(permission: ProgrammedExecution): ProgrammedExecution {

    let copyExecution: ProgrammedExecution = new ProgrammedExecution();
 
    copyExecution = Object.create(permission);

    return copyExecution;
  }
}
